<template>
  <b-modal
    id="webhook-log-modal"
    ref="webhookLogModal"
    title="Webhook Details"
    hide-footer
    size="lg">
    <label
      class="col-form-label pt-0">
      Response Status Code
    </label>
    <div class="mb-2">
      <span
        :class="getStatus(logp.response_status_code)"
        class="tag-item">{{ logp.response_status_code }}</span>
    </div>
    <label
      class="col-form-label pt-0">
      Request Headers
    </label>
    <highlight-code lang="json">
      {{ logp.request_headers }}
    </highlight-code>
    <label
      class="col-form-label pt-0">
      Request Body
    </label>
    <highlight-code lang="json">
      {{ logp.request_body }}
    </highlight-code>
    <label
      class="col-form-label pt-0">
      Response Headers
    </label>
    <highlight-code lang="json">
      {{ logp.response_headers }}
    </highlight-code>
    <label
      class="col-form-label pt-0">
      Response Body
    </label>
    <highlight-code lang="json">
      {{ logp.response_body }}
    </highlight-code>
  </b-modal>
</template>

<script>
export default {
  name: 'WebhookLogModal',
  props: {
    logp: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getStatus(statusCode = 200) {
      const statusFirstNumber = statusCode.toString().charAt(0);

      switch (statusFirstNumber) {
        case '2': {
          return 'success';
        }
        case '3':
        case '4': {
          return 'warning';
        }
        case '5': {
          return 'danger';
        }
        default: {
          return 'warning';
        }
      }
    },
    show() {
      this.$refs.webhookLogModal.show();
    },
    hide() {
      this.$refs.webhookLogModal.hide();
    },
  },
};
</script>

<style>
  .hljs {
    margin-top: 0;
  }
</style>
